const navigate = (lat, lng, address) => {
  const label = address ? encodeURIComponent(address) : `${lat},${lng}`;
  
  // Rilevamento piattaforma iOS/Android
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  // Costruzione URL appropriato per la piattaforma
  const url = isIOS 
    ? `maps://maps.apple.com/?daddr=${lat},${lng}`
    : `geo:${lat},${lng}?q=${lat},${lng}(${label})`;

  // Avvia la navigazione
  const link = document.createElement('a');
  link.href = url;
  link.style.display = 'none';
  document.body.appendChild(link);
  link.click();
  
  // Pulizia del DOM
  setTimeout(() => document.body.removeChild(link), 100);
};

export default navigate;